// extracted by mini-css-extract-plugin
module.exports = {"send_wrapper":"Sended_send_wrapper__rSkYe","send_heading":"Sended_send_heading__eDGo5","send_description":"Sended_send_description___4u0O"};